import React, { useState, useEffect } from "react";
import { Route, Routes } from "react-router-dom";
import { Toaster } from "react-hot-toast";
import { Analytics } from "@vercel/analytics/react";
import LoadingPage from "./GuessTheBTC/LoadingPage";
import GuessTheBTC from "./GuessTheBTC/GuessTheBTC";
import ApiService from "./services/ApiService";
import { motion, AnimatePresence } from "framer-motion"; // Import framer-motion for animations

export default function App() {
  const homepage = process.env.REACT_APP_HOMEPAGE || "";
  const [info, setInfo] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [hasError, setHasError] = useState(true);

  useEffect(() => {
    async function fetchInfo() {
      try {
        console.log(`fetchInfo()`);
        const api = new ApiService();
        const response = await api.get(`guessthebtc/getinfo`);
        console.log(`fetchInfo() response:`, response);
        if (
          response &&
          response["2025"] &&
          response["2025"].lowInfo &&
          response["2025"].highInfo
        ) {
          setInfo(response);
          setHasError(false);
        } else {
          throw new Error("Couldn't get info from backend");
        }
      } catch (error) {
        console.error("Error fetching info:", error);
        setHasError(true);
      } finally {
        setTimeout(() => setIsLoading(false), 300); // Show loading for at least 0.5 seconds
      }
    }

    // Start a timeout to display the error if not loaded within 9 seconds
    const timeout = setTimeout(() => {
      if (!info) {
        // setHasError(true);
        setIsLoading(false);
      }
    }, 9000);

    fetchInfo();

    return () => clearTimeout(timeout); // Clean up timeout on unmount
  }, []);

  return (
    <>
      <Toaster
        containerStyle={{
          top: 100,
        }}
        toastOptions={{
          style: {
            background: "#175d8c",
            color: "#fff",
          },
        }}
      />
      <div className={"main"}>
        <AnimatePresence>
          {isLoading ? (
            <motion.div
              key="loading"
              initial={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              transition={{ duration: 0.5 }}
            >
              <LoadingPage />
            </motion.div>
          ) : hasError ? (
            <motion.div
              key="error"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 0.5 }}
              className="error-msg"
            >
              Could not connect to server. Please try again later.
              <br />
              If problem persists please notify{" "}
              <a href="https://reddit.com/u/YouNeedAVacation">
                /u/YouNeedAVacation
              </a>
            </motion.div>
          ) : (
            info && (
              <motion.div
                key="content"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 0.5 }}
              >
                <Routes>
                  <Route path="" element={<GuessTheBTC info={info} />} />
                </Routes>
              </motion.div>
            )
          )}
        </AnimatePresence>
      </div>
      <Analytics />
    </>
  );
}
